// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__CHeZP","content":"styles_content__2UDDG","checkbox":"styles_checkbox__WEq5D","checkboxLabel":"styles_checkboxLabel__1TQcJ"};